export default "__VITE_ASSET__Dw$j5joh__"